// extracted by mini-css-extract-plugin
module.exports = {"btn":"remove-item_btn__VdCqy","icon":"remove-item_icon__pL5FW"};